import { DateTime } from 'luxon';

export const formatDateTime = (date: any | undefined): string => {
  if (date === undefined) {
    return 'N/A';
  }

  const timeStamp = DateTime.fromISO(date);

  return timeStamp.toLocal().toFormat('yyyy/MM/dd');
};

export const formatDate = (date: any | undefined): string => {
  if (!date) {
    return 'N/A';
  }

  const timeStamp = DateTime.fromISO(date);

  return timeStamp.toLocaleString(DateTime.DATE_MED);
};

export const formatTime = (date: any | undefined): string => {
  if (date === undefined) {
    return 'N/A';
  }

  const timeStamp = DateTime.fromISO(date);

  return timeStamp.toLocaleString(DateTime.TIME_SIMPLE);
};

export const formatCreatedDate = (date: any | undefined): string => {
  if (date === undefined) {
    return 'N/A';
  }

  const timeStamp = DateTime.fromISO(date);

  return timeStamp.toFormat('yyyy/MM');
};
